import { Box, Typography } from '@mui/material';
import Iconify from '../Iconify';
import { useMemo } from 'react';
import '../../css/contracts/contractRenewStatus.css';

const ContractRenewStatus = ({ status }) => {

    const displayStatus = status || false;

    const icon = useMemo(() => {
        switch (displayStatus) {
            case true:
                return 'material-symbols-light:check';
            case false:
                return 'ant-design:stop-outlined';
            default:
                return 'ant-design:stop-outlined';
        }
    }, [displayStatus]);

    const statusLabel = useMemo(() => {
        switch (displayStatus) {
            case true:
                return 'Automatique';
            case false:
                return 'Non automatique';
            default:
                return 'Non automatique';
        }
    }, [displayStatus])

    const statusColor = useMemo(() => {
        switch (displayStatus) {
            case true:
                return '#309129';
            case false:
                return '#F12525';
            default:
                return '#F12525';
        }
    }, [displayStatus]);

    return (
        <Box className='contract_status_Box' sx={{ color: statusColor, borderColor: statusColor }}>
            <Iconify icon={icon} className='contract_status_icon' />
            <Typography className='contract_status'>{statusLabel}</Typography>
        </Box>
    );
};

export default ContractRenewStatus;